import React from 'react';
import { Button, Typography, Avatar, DialogActions, DialogTitle, DialogContent, TextField, Stack, } from '@mui/material';
import { VpnKey } from '@mui/icons-material';
import { C, CenterContent, D, UploadFiles } from '../include';


class ChangePwd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayName: this.props.user ? this.props.user.name : '',
      email: this.props.user ? this.props.user.email : '',
      password: '',
      passwordConfirm: '',
      errors: {},
    };
  }

  handleSave = () => {
    const { password, passwordConfirm } = this.state;
    let errors = {};

    if (password.length < 4) {
      errors.password = 'Muito curto';
    }

    if (password !== passwordConfirm) {
      errors.passwordConfirm = 'Senhas diferentes';
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const dt = {
      displayName: this.state.displayName,
      email: this.state.email,
      password: this.state.password,
    };

    this.props.api
      .put('/user_data/', dt)
      .then((r) => {
        this.props.dialogClose();
        this.props.alert('Senha alterada com sucesso');
      })
      .catch((e) => this.props.alert('Ocorreu um erro ao alterar a senha'));
  };

  render() {
    const { password, passwordConfirm, errors } = this.state;

    return (
      <>
        <DialogTitle style={{ minWidth: '400px' }}>Trocar senha</DialogTitle>
        <DialogContent>
          <D h="0.5rem" />
          <Stack spacing={2}>
          <TextField
            required
            type="password"
            value={password}
            onChange={(e) => this.setState({ password: e.target.value })}
            name="password"
            label="Nova senha"
            error={!!errors.password}
            helperText={errors.password}
            fullWidth
          />
          <TextField
            required
            type="password"
            value={passwordConfirm}
            onChange={(e) => this.setState({ passwordConfirm: e.target.value })}
            name="passwordConfirm"
            label="Confirmar senha"
            error={!!errors.passwordConfirm}
            helperText={errors.passwordConfirm}
            fullWidth
          />
          </Stack>
          <D h="0.5rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" onClick={this.handleSave}>
            Salvar
          </Button>
        </DialogActions>
      </>
    );
  }
}

export class MyProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previous_photo_file_id: this.props.user ? this.props.user.photo_file_id : -1,
      photo_file_id: this.props.user ? this.props.user.photo_file_id : -1,
      photo_file: "",
      view_accept_photo: false
    };
  }  
  
  componentDidMount() {
    if(this.state.photo_file_id > 0)
      this.getFileFromFileServer(this.state.photo_file_id);
  }
  
  handleDBRecord = (record, error) => {
    if(!error){
      this.setState({photo_file_id: record.id, view_accept_photo: true });
      this.getFileFromFileServer(record.id);
    }
  }

  getFileFromFileServer = (id) => {
    this.props.api
      .get('/FileServer/file/' + id, {responseType: 'blob'})
      .then((r) => {
        if( r.type !== "application/json" ){  
          const url = URL.createObjectURL(r);
        
          // in case you don't need the blob anymore, blob can be garbage collected
          //img.onload = e => URL.revokeObjectURL(url);
        
          this.setState({photo_file: url});
        }
        else{
          try{  
          const outurl = URL.createObjectURL(r);
          fetch(outurl).then(res => {
            res.text().then(txt => {
              var dic = JSON.parse(txt);
              var msg = dic.error
              if(dic.coldstorage)
                msg = msg + ". Arquivo dispónível somente no coldstorage."
              this.props.alert(msg);
            });  
          });
          }catch(err){
            console.log(err);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  
  handleAcceptPhoto = () => {
    this.props.api
      .put('/user_profile_photo', { file_id: this.state.photo_file_id, previous_file_id: this.state.previous_photo_file_id })
      .then((r) => {
        if("error" in r)
          this.props.alert(r.error);
        else{
          this.props.alert(r.message);
          this.setState({view_accept_photo: false });
          this.getFileFromFileServer(this.state.photo_file_id);
        }
    })
      .catch(() => this.props.alert('Ocorreu um erro ao aceitar alterações'));  
  }
  
  render() {
    return (
      <CenterContent className="r2c e aF scB" style={{ padding: '2rem 3rem' }} p="11">
        <D className="col aC">
          {(this.state.photo_file_id !== -1) ? (
            <img
              alt=""
              src={this.state.photo_file}
              style={{ width: '200px', height: '200px' }}
            />
          ) : (
            <Avatar sx={{ width: 200, height: 200 }} />
          )}
          <D h="2rem" />
          <D>
            <Typography variant="h4" color="inherit">
              {this.props.user.name}
            </Typography>
          </D>
          {this.state.view_accept_photo && <Button
              variant="outlined"
              color="primary"
              onClick={() => this.handleAcceptPhoto() }
            >
              Aceitar Foto
            </Button>
          }
          <UploadFiles 
            api={this.props.api}
            alert={this.props.alert}
            multiple={false}
            chunkSize={3 * 1024 * 1024}
            maxFileSizeMB={2}
            acceptableFileTypes={".jpg, .png, .jpeg"} 
            onFinish={(record, error) => { this.handleDBRecord(record, error) }}
            registerIntoDB={true}
            caption="Trocar foto (200 x 200)"
          />
          
          <D e />
        </D>
        <D size="3rem" h="3rem" />
        <D className="col e aF">
          <Stack spacing={2}>
          <TextField
            type="text"
            name="name"
            label="Nome"
            defaultValue={this.props.user.name}
            disabled={!this.props.edit}
            fullWidth
          />
          <TextField
            type="text"
            name="email"
            label="Email"
            defaultValue={this.props.user.email}
            disabled={!this.props.edit}
            fullWidth
          />
          <TextField
            type="text"
            name="perfil"
            label="Perfil de Acesso"
            defaultValue={this.props.user.role}
            disabled={!this.props.edit}
            fullWidth
          />
          <TextField
            type="text"
            name="company"
            label={C.companyLabel}
            defaultValue={this.props.user.company}
            disabled={!this.props.edit}
            fullWidth
          />
          </Stack>
          <D h="2rem" />
          <D className="row w aC">
            <Button
              variant="outlined"
              color="primary"
              onClick={() =>
                this.props.dialog(
                  <ChangePwd
                    api={this.props.api}
                    user={this.props.user}
                    alert={this.props.alert}
                    dialogClose={this.props.dialogClose}
                  />
                )
              }
            >
              <VpnKey />
              Trocar senha
            </Button>
          </D>
          <D h="2rem" />
        </D>
      </CenterContent>
    );
  }
}
